/**
 * Created by Jan on 08.05.2017.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Animations = Lfl.Animations || {};

    (function (Animations, $, undefined) {
        /**
         * @memberOf Lfl.Animations
         */
        Lfl.Animations.PerformanceLeveling = Animations.PerformanceLeveling || {};

        (function (PerformanceLeveling, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.Animations.PerformanceLeveling, 'Disabler')) {
                return;
            }

            /*
             |==========================================================================================================
             | Documentation
             |==========================================================================================================
             */

            /**
             * Allows for disabling or enabling of specific animations.
             *
             * Primarily used for debugging.
             *
             * @memberOf Lfl.Animations.PerformanceLeveling
             */
            Lfl.Animations.PerformanceLeveling.Disabler = PerformanceLeveling.Disabler || {};

            (function (Disabler, $, undefined) {
                /*
                 |=======================================================================================================
                 | Object definition
                 |=======================================================================================================
                 */
                /**
                 * Whether animations not explicitly defined should be enabled or disabled (true / false).
                 * @type {boolean}
                 */
                var ENABLE_UNDEFINED = false;

                /**
                 * The prefix used for search string parameters.
                 *
                 * E.g. localhost/my-page?anim_cool_stuff=true&anim_boring_stuff=false
                 *
                 * @type {string}
                 */
                var PREFIX = "anim_";

                /**
                 * A regular expression to clear prefixes.
                 * @type {RegExp}
                 */
                var CLEAN_PREFIX_RE = new RegExp(PREFIX, "g");

                /**
                 *
                 * @type {{string: boolean}}
                 */
                var enabled = {};

                var isInitialized = false;

                function lazyInitIfNeeded() {
                    if(isInitialized !== false) {
                        return;
                    }

                    loadSettingsFromUrl();

                    isInitialized = true;
                }

                /*
                 |-------------------------------------------------------------------------------------------------------
                 | Public methods
                 |-------------------------------------------------------------------------------------------------------
                 */

                /**
                 * Whether a given animation type is currently enabled.
                 * @param {string}animationName
                 * @memberOf Lfl.Animations.PerformanceLeveling.Disabler
                 */

                Disabler.isEnabled = function (animationName) {
                    lazyInitIfNeeded();
                    return enabled[Lfl.String.toUnderscore(animationName).toUpperCase()] === true;
                };

                /*
                 |-------------------------------------------------------------------------------------------------------
                 | Private methods
                 |-------------------------------------------------------------------------------------------------------
                 */


                function loadSettingsFromUrl() {
                    var searchParameters = Lfl.Urls.ParametersProcessor.getSearchParameters();

                    _.each(searchParameters, function (/* string[] */ value, /* string */ name) {
                        if (isParameterRelevant(name)) {
                            processParameter(name, value);
                        }
                    });
                }

                /**
                 * Whether a given search parameter relates to the Disabler.
                 * @param name
                 * @returns {boolean}
                 */
                function isParameterRelevant(name) {
                    return name.startsWith(PREFIX);
                }

                /**
                 *
                 * @param {string} name
                 * @param {string[]} value
                 */
                function processParameter(name, value) {
                    var cleanedName = Lfl.String.toUnderscore(name.replace(CLEAN_PREFIX_RE, '')).toUpperCase();

                    enabled[cleanedName] = Lfl.Urls.ParametersProcessor.isTrue(value, ["enabled"]);
                }

            }(PerformanceLeveling.Disabler, jQuery));
        }(Animations.PerformanceLeveling, jQuery));
    }(Lfl.Animations, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
